import DtoDetailSite from './DtoDetailSite'
import DtoWaterMass from './DtoWaterMass'
import DtoHydrologicalArea from './DtoHydrologicalArea'

import {
	STATION_NATURE_SEAPORT,
	STATION_NATURE_PIEZOMETER,
	STATION_NATURE_QUALITOMETER,
	STATION_NATURE_PLUVIOMETER,
	STATION_NATURE_POLLUTED_SOIL,
	STATION_NATURE_INDUSTRIAL_SITE,
	STATION_NATURE_HYDROLOGICAL_STATION,
	STATION_NATURE_TREATMENT_STATION
} from '../constants/StationNatureConstants'

export default class {

	constructor(obj) {
		this.code = obj.code
		this.altitude = obj.altitude
		this.beginningDate = obj.beginningDate
		this.endingDate = obj.endingDate
		this.natureStation = obj.natureStation
		if (obj.hydrologicArea) {
			this.hydrologicArea = new DtoHydrologicalArea(obj.hydrologicArea)
		}
		if (obj.waterMass) {
			this.waterMass = new DtoWaterMass(obj.waterMass)
		}
		this.site = new DtoDetailSite(obj.site)
	}

	isPiezometer() {
		return this.natureStation.indexOf(STATION_NATURE_PIEZOMETER) !== -1
	}

	isQualitometer() {
		return this.natureStation.indexOf(STATION_NATURE_QUALITOMETER) !== -1
	}

	isSeaport() {
		return this.natureStation.indexOf(STATION_NATURE_SEAPORT) !== -1
	}

	isPluviometer() {
		return this.natureStation.indexOf(STATION_NATURE_PLUVIOMETER) !== -1
	}

	isPollutedSoil() {
		return this.natureStation.indexOf(STATION_NATURE_POLLUTED_SOIL) !== -1
	}

	isIndustrialSite() {
		return this.natureStation.indexOf(STATION_NATURE_INDUSTRIAL_SITE) !== -1
	}

	isHydrologicalStation() {
		return this.natureStation.indexOf(STATION_NATURE_HYDROLOGICAL_STATION) !== -1
	}

	isTreatmentStation() {
		return this.natureStation.indexOf(STATION_NATURE_TREATMENT_STATION) !== -1
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoDetailStation.js